import { createLogger } from './bf-lp1-logger.js';
import { initializeCustomElements } from './bf-lp1-custom-elements.js';
import './bf-lp1-quiz.js'; // Import the quiz module to trigger its IIFE

// Import Tailwind styles
import './bf-lp1.css';

const logger = createLogger(false, 'bf-lp1', 'info');

function initializeAll() {
    logger.info('Initializing all bf-lp1 components');
    initializeCustomElements();
}

// Initialize on solutionsShown event
document.addEventListener('solutionsShown', initializeAll);

// Initialize on DOM load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
} else {
    initializeAll();
}

// Export for potential manual initialization
export { initializeAll }; 